import React, {Component} from 'react';
import '../../../../styles/Home.css'
import {Button} from "react-bootstrap";
import Dropzone from "react-dropzone";
import BOKService from "./BOKService";
import {saveAs} from 'file-saver';
import Panel from "../../Panel";
import {NotificationManager} from "react-notifications";

export default class MojeBilety extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: [],
            data2: [],
            tresc: '',
            temat: '',
            zgloszenie: '',
            plik: [],
            plikBase: '',
            plikInvalid: false,
            trescInvalid: false,
        };

        this.handleTresc = this.handleTresc.bind(this);
        this.handleTemat = this.handleTemat.bind(this)
    }

    componentDidMount() {
        BOKService.getZgloszenie(this.props.match.params.index)
            .then(function (response) {
                BOKService.postOdczytano(this.props.match.params.index)
                this.setState({
                    data: response.data,
                    data2: response.data.bokZglWpisy,
                    zgloszenie: response.data.bokZglWpisy[0],
                    loading: false
                })
            }.bind(this));

    }

    handleTresc(e) {
        this.setState({tresc: e.target.value})
    }

    handleTemat(e) {
        this.setState({temat: e.target.value})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plikInvalid: true, plik: []})
        } else {
            this.getBase64(accepted);
            this.setState({plikInvalid: false, plik: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({plikBase: reader.result.substr(reader.result.indexOf(',') + 1)})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    wyslijZgloszenie() {
        if (this.state.tresc.length > 0) {
            this.postZgloszenie()
        } else {
            let tresc;
            if (this.state.tresc.length <= 0) {
                tresc = true
            }
            this.setState({trescInvalid: tresc})
        }
    }

    pobierzPlik(b64Data, contentType, filename) {
        let sliceSize = 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let file = new File(byteArrays, filename, {type: contentType});
        saveAs(file, filename)
    }

    postZgloszenie() {
        let name = '';
        let type = '';
        let size = 0;
        let plik = null;
        if (this.state.plik[0] !== null && this.state.plik[0] !== undefined) {
            plik = this.state.plikBase;
            name = this.state.plik[0].name;
            size = this.state.plik[0].size;
            type = this.state.plik[0].type
        }
        BOKService.postZgloszenieId(plik, name, size, type,
            this.state.tresc, JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.props.match.params.index)
            .then(function (response) {
                this.setState({
                    tresc: '',
                    plik: [],
                    plikBase: '',
                    plikInvalid: false
                });
                NotificationManager.success("", "Zgłoszenie zostało wysłane ", 5000);
                this.componentDidMount();
            }.bind(this))
            .catch((e) => {
                console.log(e)
            })
    }

    zamknijWatek() {
        BOKService.postZamknij(this.props.match.params.index)
            .then(function (response) {
                NotificationManager.success("", "Wątek został zamknięty ", 5000);
                this.componentDidMount();
            }.bind(this))
            .catch((e) => {
                console.log(e)
            })
    }

    render() {
        return <Panel>
            <div>

                <h4 style={{textAlign: 'center', marginBottom: 10}}><b>Biuro Obsługi Klienta</b></h4>
                <div className="text-center" style={{fontWeight: 'bold'}}>Zgłoszenie id: {this.state.data.idZgl}</div>
                <br/>

                {this.state.loading ? <div>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>

                    <div className="text-right">{this.state.data.status === 0 ? <div>
                            <small><font color='#8dc846'>Wątek otwarty<i
                                className="fa fa-check" aria-hidden="true"> </i></font></small>
                        </div> :
                        <div>
                            <small><font color='#989898'>Wątek zamknięty<i
                                className="fa fa-times" aria-hidden="true"> </i></font></small>
                        </div>
                    }</div>
                    <div className="row">
                        <div className="col-sm-12 wynik">
                            <div className="row naglowekSzczegolyBok">
                                <div className="col-sm-12">Szczegóły i treść zgłoszenia</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 tematBok"><b>Temat zgłoszenia:</b> {this.state.data.temat}
                                </div>
                                <div className="col-sm-6 dataBok text-right"><i
                                    className="fa fa-calendar"> </i> {this.state.data.dataWpisu.substr(0, 10) + ' ' + this.state.data.dataWpisu.substr(11, 5)}
                                </div>
                                <div className="col-sm-6 zglaszajacyBok">
                                    <b>Autor:</b> {this.state.data.imieKl + ' ' + this.state.data.nazKl}
                                </div>
                                {this.state.data.nrBil !== null ? <div className="col-sm-6 text-right">
                                    <i className="fa fa-ticket"> </i> {this.state.data.nrBil}
                                </div> : null}
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-sm-12 trescBok"><b>Treść:</b>
                                    <p style={{wordWrap: 'break-word'}}>
                                        {this.state.zgloszenie.tresc}
                                    </p>
                                </div>
                            </div>
                            {this.state.zgloszenie.plik !== null ?
                                <div className="small">
                                    <hr/>
                                    <b>Załącznik:</b>
                                    <span style={{cursor: 'pointer'}}
                                          onClick={() => this.pobierzPlik(this.state.zgloszenie.plik.dane, this.state.zgloszenie.plik.typ, this.state.zgloszenie.plik.nazwa)}>
                            <i className="fa fa-paperclip"
                               aria-hidden="true"> </i>{this.state.zgloszenie.plik.nazwa}
                            </span>
                                </div>
                                : null}
                        </div>
                    </div>

                    <hr/>

                    <h5 style={{marginTop: 25, marginBottom: 15}}><b>Odpowiedzi:</b></h5>
                    {this.state.data2.length === 1 ?
                        <div className="text-center" style={{fontSize: '1.25rem', marginTop: 50, marginBottom: 50}}>Brak
                            odpowiedzi</div> :
                        <div>{this.state.data2.map((item, index) => {
                            if (index === 0) {
                                return null;
                            } else {
                                if (item.kierunek !== 'KLIENT') {
                                    return <div className="row" style={{marginTop: 10, marginLeft: 10}}>
                                        <div className="col-sm-12 wynik">
                                            <div className="row naglowekOdpowiedziBok">
                                                <div className="col-sm-12">Odpowiedź #{index}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 tematBok">
                                                    <b>Autor:</b> BOK
                                                </div>
                                                <div className="col-sm-6 dataBok text-right"><i
                                                    className="fa fa-calendar"> </i> {item.dataWpisu.substr(0, 10) + ' ' + item.dataWpisu.substr(11, 5)}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-12 trescBok"><b>Treść:</b>
                                                    <p>
                                                        {item.tresc}
                                                    </p>
                                                </div>
                                            </div>
                                            {item.plik !== null ?
                                                <div className="small">
                                                    <hr/>
                                                    <b>Załącznik:</b>
                                                    <span style={{cursor: 'pointer'}}
                                                          onClick={() => this.pobierzPlik(item.plik.dane, item.plik.typ, item.plik.nazwa)}>
                                    <i className="fa fa-paperclip"
                                       aria-hidden="true"> </i>{item.plik.nazwa}
                                </span>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                } else {
                                    return <div className="row" style={{marginTop: 10, marginRight: 10}}>
                                        <div className="col-sm-12 wynik">
                                            <div className="row naglowekSzczegolyBok">
                                                <div className="col-sm-12">Odpowiedź #{index}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 tematBok">
                                                    <b>Autor:</b> {item.imie + ' ' + item.nazwisko}</div>
                                                <div className="col-sm-6 dataBok text-right"><i
                                                    className="fa fa-calendar"> </i> {item.dataWpisu.substr(0, 10) + ' ' + item.dataWpisu.substr(11, 5)}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-12 trescBok"><b>Treść:</b>
                                                    <p style={{wordWrap: 'break-word'}}>
                                                        {item.tresc}
                                                    </p>
                                                </div>
                                            </div>
                                            {item.plik !== null ?
                                                <div className="small">
                                                    <hr/>
                                                    <b>Załącznik:</b>
                                                    <span style={{cursor: 'pointer'}}
                                                          onClick={() => this.pobierzPlik(item.plik.dane, item.plik.typ, item.plik.nazwa)}>
                                    <i className="fa fa-paperclip"
                                       aria-hidden="true"> </i>{item.plik.nazwa}
                                </span>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                }
                            }
                        })}</div>}
                </div>}
                {this.state.data.status === 0 ? <div>
                    <hr/>
                    <h5 style={{marginTop: 25}}><b>Odpowiedz:</b></h5>
                    <div style={{marginTop: 25}}>
                        <div>
                            <b>Treść wiadomości: </b>
                            <textarea rows={8} value={this.state.tresc} maxLength={1000} onChange={this.handleTresc}
                                      style={{
                                          marginTop: 10,
                                          width: '100%',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: 5,
                                          padding: 10
                                      }}
                                      placeholder={"Wpisz wiadomość..."}/>
                            {this.state.trescInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                    treść.</div> : null}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <b>Plik: </b>
                                <Dropzone maxSize={10000000}
                                          accept={'image/jpeg, image/png, application/pdf'}
                                          style={{
                                              maxWidth: '100%',
                                              height: 150,
                                              border: '1px dashed #ced4da',
                                              borderRadius: '0.25rem',
                                              paddingTop: 15,
                                              marginTop: 10,
                                              marginBottom: 10,
                                              textAlign: 'center',
                                              fontSize: '0.875rem',
                                              color: '#565756',
                                              cursor: 'pointer'
                                          }}
                                          onDrop={(accepted, rejected) => {
                                              this.onDrop(accepted, rejected)
                                          }}>
                                    {this.state.plik.length === 0 ? <div>
                                        <div style={{paddingTop: '5%'}}>Maksymalny rozmiar pliku: 10mb</div>
                                        <div style={{color: '#1e90ff'}}>Akceptowane typy plików: .png, .jpg, .jpeg,
                                            .pdf
                                        </div>
                                        {this.state.plikInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Format lub rozmiar pliku nie może zostać
                                                zaakceptowany.</div> : null}
                                    </div> : <div>
                                        <div style={{paddingTop: '4%'}}><b>{this.state.plik[0].name}</b></div>
                                        <p>(Kliknij by zmienić plik)</p>
                                    </div>}
                                </Dropzone>
                            </div>
                        </div>
                        <div className="text-right">
                            <Button bsStyle={'danger'} style={{marginRight: 15}} onClick={() => {
                                this.zamknijWatek()
                            }}>Zamknij wątek</Button>
                            <Button bsStyle={'success'} onClick={() => {
                                this.wyslijZgloszenie()
                            }}>Wyślij odpowiedź</Button>
                        </div>
                    </div>
                </div> : null}
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/bokComponents/BOKszczegoly.js